// extracted by mini-css-extract-plugin
export default {"lessonCardModalContainer":"PurchaseModal_lessonCardModalContainer__9LBiH","outer":"PurchaseModal_outer__GKZ4b","inner":"PurchaseModal_inner__ZLAoP"};